import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { FormOf } from '@devinco/ui/legacy';

import {
  FormValueType,
  MergeableTrip,
} from '@pages/trips-page/components/merge-trip-tab/interfaces';
import { DvDynamicFormElement } from '@devinco/ui/legacy';
@Component({
  selector: 'app-mergeable-trips-table',
  templateUrl: './mergeable-trips-table.component.html',
  styleUrls: ['./mergeable-trips-table.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class MergeableTripsTableComponent {
  @Input() tripsToMerge: MergeableTrip[] = [];
  @Input() mergeTripElements: DvDynamicFormElement[] = [];
  @Input() mergeTripForm: FormGroup<FormOf<FormValueType>> | undefined;

  checkboxChecked(isChecked: boolean, control: FormControl): void {
    control.setValue(isChecked);
  }
}
